import coverImg from "assets/images/v112/cover.webp"

export const v112Config = {
  cover: {
    en: coverImg,
  },
}
